"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Drawer: true
};
exports.Drawer = void 0;
var _react = _interopRequireDefault(require("react"));
var _rcDrawer = _interopRequireDefault(require("rc-drawer"));
var _close = require("../../assets/icons/close.svg");
var _drawerModule = _interopRequireDefault(require("./drawer.module.scss"));
var _useDrawer = require("./useDrawer");
Object.keys(_useDrawer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useDrawer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useDrawer[key];
    }
  });
});
var Drawer = function Drawer(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    title = _ref.title,
    children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_rcDrawer.default, {
    open: isOpen,
    onClose: onClose,
    handler: false,
    showMask: true,
    level: null,
    placement: 'right'
  }, title && /*#__PURE__*/_react.default.createElement("div", {
    className: _drawerModule.default['drawer__header']
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _drawerModule.default['drawer__title']
  }, title), /*#__PURE__*/_react.default.createElement(_close.ReactComponent, {
    "data-testid": "close-icon",
    onClick: onClose,
    className: _drawerModule.default['drawer__close-icon']
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _drawerModule.default['drawer__body'],
    "data-testid": "drawer-body"
  }, children));
};
exports.Drawer = Drawer;